import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';
import throttle from 'lodash/throttle';
import { apis } from '../../config';
import { api } from '../../api/api';
import { deriveCoreTrackErrorCode } from '../../utils/coreTrackErrorCode';
import { mailTable } from '../logical/mail/mail_action_store_model';
import { attachmentTypeMap, } from '../../api/system/fileLoader';
import { ListStore } from '../../api/commonModel';
import FileManageDb from './file_dbl';
import { mailPerfTool } from '@/api/util/mail_perf';
import { getOs } from '../../utils/confOs';
const MAIL_CORE_FLOW_RESULT_EVENT_ID = 'pc_mail_core_flow_result';
const MAIL_CORE_API_RESULT_EVENT_ID = 'pc_mail_core_api_result';
class FileApiImp {
    constructor() {
        this.fsDownloadManage = {};
        this.performanceApi = api.requireLogicalApi(apis.performanceImpl);
        this.commonPieceUploadConf = {
            contentType: 'stream',
            timeout: 20 * 60 * 1000,
        };
        this.name = apis.defaultFileApi;
        this.systemApi = api.getSystemApi();
        this.eventApi = api.getEventApi();
        this.httpApi = api.getDataTransApi();
        this.store = new ListStore();
        this.mailConfApi = api.requireLogicalApi(apis.mailConfApiImpl);
        this.fileIndex = {};
        this.fileDb = new FileManageDb();
        this.accountApi = api.requireLogicalApi(apis.accountApiImpl);
        this.dataTrakerApi = api.requireLogicalApi(apis.dataTrackerApiImp);
    }
    saveImportMails(mailInfos, _account) {
        return this.fileDb.putImportMails(mailInfos, _account).then((res) => {
            if (res.length) {
                return res.map(mailInfo => mailInfo.__prKey__);
            }
            return [];
        });
    }
    checkMailMd5Exists(md5List, _account) {
        return this.fileDb.getImportMailByMd5(md5List, _account);
    }
    afterLogin(ev) {
        if (ev && ev.data) {
            this.fileDb.init();
        }
        return this.name;
    }
    beforeLogout() {
        this.fileDb.close();
        return this.name;
    }
    init() {
        return this.name;
    }
    afterInit() {
        if (this.systemApi.getCurrentUser()) {
            this.fileDb.init();
        }
        return this.name;
    }
    afterLoadFinish() {
        return this.name;
    }
    setFsDownloadStatus(url, file) {
        const noLog = file.fileStatus === 'downloading';
        const cur = Object.assign(this.getFsDownloadStatus(url) || {}, file);
        this.fsDownloadManage[url] = cur;
        this.eventApi.sendSysEvent({
            eventName: 'fsDownloadNotify',
            eventStrData: url,
            eventData: cur,
            eventSeq: 0,
            noLog,
        });
    }
    getFsDownloadStatus(url) {
        return this.fsDownloadManage[url];
    }
    clearFsDownloadStatus(url) {
        delete this.fsDownloadManage[url];
    }
    abortFsDownload(url) {
        window.electronLib.downloadManage.downloadAbort(url);
        this.clearFsDownloadStatus(url);
    }
    async batchDownload(req, conf) {
        var _a;
        const { fileContent, filePath: path } = req;
        if (((_a = fileContent) === null || _a === void 0 ? void 0 : _a.byteLength) && path) {
            return new Promise((resolve, reject) => {
                window.electronLib.fsManage.writeFile(Buffer.from(fileContent), path, {}, (err) => {
                    if (err) {
                        reject({
                            succ: false,
                            path,
                            reason: err,
                        });
                    }
                    else {
                        resolve({
                            succ: true,
                            fileModel: req,
                        });
                    }
                });
            });
        }
        return this.download(req, conf);
    }
    filterSafeDownloadFilename(filename) {
        return filename === null || filename === void 0 ? void 0 : filename.replace(/[?:*|!$/]+/gi, '_');
    }
    preCheckFile(req, hostPath) {
        let totalSize = 0;
        const dealedFiles = req.reduce((total, r) => {
            if (r.filePath) {
                return [...total, r];
            }
            let { fileName } = r;
            const { fileSize } = r;
            fileName = this.filterSafeDownloadFilename(fileName);
            totalSize += fileSize;
            const matches = /\.[^\.]+$/.exec(fileName);
            const ext = matches ? matches[0] : '';
            let frontName = ext ? fileName.split(ext)[0] : fileName;
            while (frontName.length > 155) {
                frontName = frontName.substring(0, frontName.length - 1);
            }
            const samenamelength = total.filter(item => {
                if (typeof item.fileName !== 'string') {
                    return false;
                }
                const reg = /^(?<count>\(\d+\)){0,1}$/;
                return !!item.fileName.replace(frontName, '').replace(ext, '').match(reg);
            }).length;
            const isExists = total.some(item => {
                if (typeof item.fileName !== 'string') {
                    return false;
                }
                return item.fileName === fileName;
            });
            frontName = samenamelength !== 0 && isExists ? `${frontName}(${samenamelength})` : frontName;
            const sep = window.electronLib.fsManage.normalizePath('/');
            return [
                ...total,
                Object.assign(Object.assign({}, r), { fileName: frontName + ext, filePath: `${hostPath}${sep}${frontName + ext}` }),
            ];
        }, []);
        return {
            totalSize,
            dealedFiles,
        };
    }
    async saveZip(req, name, mailId, options = {}) {
        const { removeOrginalFile, _account = '', flowScene = 'mail_read' } = options;
        if (this.systemApi.isElectron() && window.electronLib) {
            const saveName = `${name}.zip`;
            const isSubAccount = this.mailConfApi.isSubAccount(_account);
            const { success, path } = await window.electronLib.windowManage.saveDialog({
                fileName: saveName,
                openAsMainWindow: isSubAccount,
            });
            const reg = getOs() === 'mac' ? /.*(?=\/[^/]+$)/ : /.*(?=\\[^\\]+$)/;
            const matchRes = path.match(reg);
            const hostPath = matchRes ? matchRes[0] : '';
            const tempPath = await window.electronLib.fsManage.mktempdir(`atc-${Date.now().toString()}-`);
            if (success) {
                const downloadStartTime = Date.now();
                const getTrackDuration = () => Math.max(Date.now() - downloadStartTime, 0);
                mailPerfTool.attachmentTransfer('download', 'all', 'start');
                const { dealedFiles, totalSize } = this.preCheckFile(req, tempPath || hostPath);
                let loadResultArr;
                try {
                    loadResultArr = (await this.asyncPool({
                        num: 3,
                        infos: dealedFiles,
                        func: this.batchDownload.bind(this),
                        conf: {
                            noStoreData: true,
                            skipCoreResultTrack: false,
                            _account,
                            flowScene,
                        },
                    }));
                }
                catch (error) {
                    mailPerfTool.attachmentTransfer('download', 'all', 'end', {
                        result: 'fail',
                        fileSize: totalSize,
                        fileType: 'zip',
                    });
                    this.trackAttachmentDownloadCoreResult({
                        scene: flowScene,
                        action: 'attachment_download_zip',
                        result: this.isDownloadCanceled(error) ? 'canceled' : 'fail',
                        failType: this.getDownloadTrackFailType(error),
                        reason: error,
                        duration: getTrackDuration(),
                        _account,
                        fileSize: totalSize,
                        fileCount: req.length,
                    });
                    return {
                        success: false,
                        path: '',
                    };
                }
                if (!(loadResultArr instanceof Array) || loadResultArr.some(_ => _.succ === false)) {
                    const failedItem = (loadResultArr || []).find((item) => (item === null || item === void 0 ? void 0 : item.succ) === false);
                    const failReason = failedItem === null || failedItem === void 0 ? void 0 : failedItem.errMsg;
                    const trackResult = this.isDownloadCanceled(failReason) ? 'canceled' : 'fail';
                    mailPerfTool.attachmentTransfer('download', 'all', 'end', {
                        result: 'fail',
                        fileSize: totalSize,
                        fileType: 'zip',
                    });
                    this.trackAttachmentDownloadCoreResult({
                        scene: flowScene,
                        action: 'attachment_download_zip',
                        result: trackResult,
                        failType: trackResult === 'fail' ? this.getDownloadTrackFailType(failReason) : 'unknown',
                        reason: failReason,
                        duration: getTrackDuration(),
                        _account,
                        fileSize: totalSize,
                        fileCount: req.length,
                    });
                    loadResultArr.forEach(r => {
                        if (!r.succ) {
                            return;
                        }
                        if (typeof r.fileModel.filePath === 'string' && r.fileModel.filePath.length > 0) {
                            window.electronLib.fsManage.remove(r.fileModel.filePath);
                        }
                        this.delFileInfo(r.fileModel);
                        this.eventApi.sendSysEvent({
                            eventName: 'fsDownloadNotify',
                            eventStrData: r.fileModel.fileUrl,
                            eventData: undefined,
                            eventSeq: 0,
                            noLog: true,
                        });
                    });
                    return {
                        success: false,
                        path: '',
                    };
                }
                const files = [];
                loadResultArr.forEach(r => {
                    r.fileModel.filePath !== undefined && files.push(r.fileModel.filePath);
                });
                const res = await window.electronLib.fsManage.zip({
                    files,
                    filePath: path,
                    fileName: saveName,
                });
                if (mailId) {
                    const mailStatus = await this.fileDb.dbApi.getById(mailTable.status, mailId);
                    if (mailStatus) {
                        mailStatus.attachmentsZipPath = res.filePath;
                        await this.fileDb.dbApi.put(mailTable.status, mailStatus);
                    }
                }
                await window.electronLib.fsManage.remove(tempPath);
                mailPerfTool.attachmentTransfer('download', 'all', 'end', {
                    result: res.success ? 'success' : 'fail',
                    fileSize: totalSize,
                    fileType: 'zip',
                });
                this.trackAttachmentDownloadCoreResult({
                    scene: flowScene,
                    action: 'attachment_download_zip',
                    result: res.success ? 'success' : 'fail',
                    failType: res.success ? undefined : this.getDownloadTrackFailType(res.message),
                    reason: res.success ? undefined : res.message,
                    duration: getTrackDuration(),
                    _account,
                    fileSize: totalSize,
                    fileCount: req.length,
                });
                if (removeOrginalFile === true) {
                    loadResultArr.forEach(r => {
                        if (typeof r.fileModel.filePath === 'string' && r.fileModel.filePath.length > 0) {
                            window.electronLib.fsManage.remove(r.fileModel.filePath);
                        }
                        this.eventApi.sendSysEvent({
                            eventName: 'fsDownloadNotify',
                            eventStrData: r.fileModel.fileUrl,
                            eventData: undefined,
                            eventSeq: 0,
                            noLog: true,
                        });
                        this.delFileInfo(r.fileModel);
                    });
                }
                return Object.assign(Object.assign({}, res), { path: res.filePath });
            }
        }
        return {
            success: false,
            path: '',
        };
    }
    async saveAll(req, _account = '', flowScene = 'mail_read') {
        if (this.systemApi.isElectron() && window.electronLib) {
            const { success, path } = await window.electronLib.windowManage.select({
                properties: ['openDirectory'],
                buttonLabel: '下载',
            });
            const hostPath = Array.isArray(path) ? path[0] : path;
            if (success) {
                const downloadStartTime = Date.now();
                const getTrackDuration = () => Math.max(Date.now() - downloadStartTime, 0);
                mailPerfTool.attachmentTransfer('download', 'all', 'start');
                const { dealedFiles, totalSize } = this.preCheckFile(req, hostPath);
                let loadResultArr;
                try {
                    loadResultArr = (await this.asyncPool({
                        num: 3,
                        infos: dealedFiles,
                        func: this.batchDownload.bind(this),
                        conf: {
                            skipCoreResultTrack: false,
                            _account,
                            flowScene,
                        },
                    }));
                }
                catch (error) {
                    mailPerfTool.attachmentTransfer('download', 'all', 'end', {
                        result: 'fail',
                        fileSize: totalSize,
                        fileType: 'zip',
                    });
                    this.trackAttachmentDownloadCoreResult({
                        scene: flowScene,
                        action: 'attachment_download_batch',
                        result: this.isDownloadCanceled(error) ? 'canceled' : 'fail',
                        failType: this.getDownloadTrackFailType(error),
                        reason: error,
                        duration: getTrackDuration(),
                        _account,
                        fileSize: totalSize,
                        fileCount: req.length,
                    });
                    return {
                        success: false,
                        path: hostPath,
                    };
                }
                if (!(loadResultArr instanceof Array) || loadResultArr.some(_ => _.succ === false)) {
                    const failedItem = (loadResultArr || []).find((item) => (item === null || item === void 0 ? void 0 : item.succ) === false);
                    const failReason = failedItem === null || failedItem === void 0 ? void 0 : failedItem.errMsg;
                    const trackResult = this.isDownloadCanceled(failReason) ? 'canceled' : 'fail';
                    mailPerfTool.attachmentTransfer('download', 'all', 'end', {
                        result: 'fail',
                        fileSize: totalSize,
                        fileType: 'zip',
                    });
                    this.trackAttachmentDownloadCoreResult({
                        scene: flowScene,
                        action: 'attachment_download_batch',
                        result: trackResult,
                        failType: trackResult === 'fail' ? this.getDownloadTrackFailType(failReason) : 'unknown',
                        reason: failReason,
                        duration: getTrackDuration(),
                        _account,
                        fileSize: totalSize,
                        fileCount: req.length,
                    });
                    return {
                        success: false,
                        path: hostPath,
                    };
                }
                this.trackAttachmentDownloadCoreResult({
                    scene: flowScene,
                    action: 'attachment_download_batch',
                    result: 'success',
                    duration: getTrackDuration(),
                    _account,
                    fileSize: totalSize,
                    fileCount: req.length,
                });
                return {
                    success: true,
                    path: hostPath,
                    loadResArr: loadResultArr,
                };
            }
            return {
                success: false,
                path: '',
            };
        }
        return {
            success: false,
            path: '',
        };
    }
    async downloadLocalFile(req) {
        if (this.systemApi.isElectron() && window.electronLib && (req === null || req === void 0 ? void 0 : req.fileName) && (req === null || req === void 0 ? void 0 : req.filePath)) {
            const isSubAccount = this.mailConfApi.isSubAccount(req === null || req === void 0 ? void 0 : req._account);
            const dialogRes = await window.electronLib.windowManage.saveDialog({
                fileName: req.fileName,
                openAsMainWindow: isSubAccount,
            });
            if (dialogRes.success) {
                await window.electronLib.fsManage.copy(req.filePath, dialogRes.path);
                return {
                    success: true,
                    path: dialogRes.path,
                };
            }
        }
        return {
            success: false,
            path: '',
        };
    }
    sysToast(text) {
        if (!text) {
            return;
        }
        this.eventApi.sendSysEvent({
            eventName: 'error',
            eventLevel: 'error',
            eventStrData: 'warn',
            eventData: {
                popupType: 'toast',
                popupLevel: 'warn',
                title: text,
                code: 'PARAM.ERR',
                auto: false,
                duration: 1.5,
            },
            eventSeq: 0,
        });
    }
    getTrackReasonText(reason) {
        if (typeof reason === 'string') {
            return reason;
        }
        if (reason instanceof Error) {
            return reason.message || '';
        }
        if (reason === undefined || reason === null) {
            return '';
        }
        try {
            return JSON.stringify(reason);
        }
        catch (error) {
            return String(reason);
        }
    }
    isDownloadCanceled(reason) {
        const reasonText = this.getTrackReasonText(reason);
        return /cancel|canceled|cancelled|取消/i.test(reasonText);
    }
    getDownloadTrackFailType(reason) {
        const reasonText = this.getTrackReasonText(reason);
        if (/timeout|timed\s*out|超时/i.test(reasonText)) {
            return 'timeout';
        }
        if (/network|interrupted|download-net-error|下载错误|net::/i.test(reasonText)) {
            return 'network';
        }
        return 'unknown';
    }
    getSingleDownloadAttachmentKind(req, recordFileType) {
        const fileReq = req;
        const reqType = (fileReq === null || fileReq === void 0 ? void 0 : fileReq.type) || (fileReq === null || fileReq === void 0 ? void 0 : fileReq.attachmentType);
        const isCloudByReq = reqType === 'netfolder' || (fileReq === null || fileReq === void 0 ? void 0 : fileReq.cloudAttachment) === true;
        const isCloud = recordFileType === 'cloud' || (recordFileType !== 'common' && isCloudByReq);
        return isCloud ? 'cloud' : 'common';
    }
    normalizeApiPath(pathname) {
        const normalized = pathname.replace(/\/+$/g, '');
        return normalized || '/';
    }
    getDownloadCoreApiFromUrl(urlText, fallbackApi) {
        try {
            if (!urlText)
                return fallbackApi || 'unknown';
            const url = new URL(urlText);
            const func = url.searchParams.get('func') || undefined;
            if (func)
                return func;
            const pathname = this.normalizeApiPath(url.pathname || '');
            return pathname || fallbackApi || 'unknown';
        }
        catch (error) {
            return fallbackApi || 'unknown';
        }
    }
    trackAttachmentDownloadCoreApiResult(params) {
        try {
            const { scene, api, attachmentKind, result, _account, reason, duration, failType, fileType, fileSize, fileCount } = params;
            const reasonText = this.getTrackReasonText(reason);
            const effectiveFailType = result === 'fail' ? failType || this.getDownloadTrackFailType(reason) : result === 'canceled' ? 'unknown' : undefined;
            const errorCode = deriveCoreTrackErrorCode({
                result,
                failType: effectiveFailType,
                reason: reasonText,
                errorObj: reason,
            });
            this.dataTrakerApi.track(MAIL_CORE_API_RESULT_EVENT_ID, Object.assign({ scene,
                api,
                attachmentKind,
                result, failType: effectiveFailType, reason: reasonText || undefined, duration,
                _account,
                fileType,
                fileSize,
                fileCount, enableTrackInBg: true }, (errorCode !== undefined ? { errorCode } : {})));
        }
        catch (error) {
            console.log('trackAttachmentDownloadCoreApiResult error', error);
        }
    }
    trackAttachmentDownloadCoreResult(params) {
        try {
            const { scene = 'unknown', action, attachmentKind, result, _account, reason, duration, failType, fileType, fileSize, fileCount } = params;
            const reasonText = this.getTrackReasonText(reason);
            const effectiveFailType = result === 'fail' ? failType || this.getDownloadTrackFailType(reason) : result === 'canceled' ? 'unknown' : undefined;
            const errorCode = deriveCoreTrackErrorCode({
                result,
                failType: effectiveFailType,
                reason: reasonText,
                errorObj: reason,
            });
            this.dataTrakerApi.track(MAIL_CORE_FLOW_RESULT_EVENT_ID, Object.assign({ scene,
                action,
                attachmentKind,
                result, failType: effectiveFailType, reason: reasonText || undefined, duration,
                _account,
                fileType,
                fileSize,
                fileCount, enableTrackInBg: true }, (errorCode !== undefined ? { errorCode } : {})));
        }
        catch (error) {
            console.log('trackAttachmentDownloadCoreResult error', error);
        }
    }
    async saveDownloadInOtherApp(req, _conf) {
        const newReq = req && (!req.fileUrl || !req.fileName) ? this.transferModel(req) : req;
        if (!req || !req.fileUrl || !req.fileName) {
            return Promise.reject(new Error('[file] download no data required'));
        }
        this.sysToast(req.dialogConfirmText || '');
        return this.downloadInOtherAppExternal(newReq);
    }
    async saveDownload(req, conf) {
        var _a;
        if (window.isInOtherApp) {
            return this.saveDownloadInOtherApp(req, conf);
        }
        const newReq = req && (!req.fileUrl || !req.fileName) ? this.transferModel(req) : req;
        if (!newReq || !newReq.fileUrl || !newReq.fileName) {
            return Promise.reject(new Error('[file] download no data required'));
        }
        const fileName = this.filterSafeDownloadFilename(newReq.fileName);
        if (this.systemApi.isElectron() && window.electronLib) {
            const isSubAccount = this.mailConfApi.isSubAccount(conf === null || conf === void 0 ? void 0 : conf._account);
            const res = await window.electronLib.windowManage.saveDialog({
                fileName,
                openAsMainWindow: isSubAccount,
            });
            if (res.success) {
                this.sysToast(newReq.dialogConfirmText || '');
                let saveAndDownload = true;
                if ((conf === null || conf === void 0 ? void 0 : conf.saveAndDownload) !== undefined) {
                    saveAndDownload = conf.saveAndDownload;
                }
                if (saveAndDownload) {
                    const base64Reg = new RegExp(/^data:image\/\w+;base64,/);
                    if (newReq.fileUrl && base64Reg.test(newReq.fileUrl)) {
                        const reqUrl = newReq.fileUrl.slice().replace(base64Reg, '');
                        return window.electronLib.fsManage.saveBase64File(res.path, reqUrl);
                    }
                    if ((_a = newReq === null || newReq === void 0 ? void 0 : newReq.fileContent) === null || _a === void 0 ? void 0 : _a.byteLength) {
                        return new Promise((resolve, reject) => {
                            window.electronLib.fsManage.writeFile(Buffer.from(newReq === null || newReq === void 0 ? void 0 : newReq.fileContent), res.path, {}, (err) => {
                                if (err) {
                                    return reject({
                                        success: false,
                                        path: res.path,
                                        reason: err,
                                    });
                                }
                                return resolve({
                                    success: true,
                                    path: res.path,
                                });
                            });
                        });
                    }
                    return this.download(Object.assign(Object.assign({}, newReq), { filePath: res.path, fileName }), conf);
                }
                return res;
            }
            return {
                success: false,
                path: '',
            };
        }
        this.sysToast(newReq.dialogConfirmText || '');
        return this.downloadExternal(newReq);
    }
    clipboardWriteImage(dataURL) {
        if (this.systemApi.isElectron() && window.electronLib) {
            window.electronLib.fsManage.clipboardWriteImage(dataURL);
        }
    }
    async download(reqO, conf) {
        let req = reqO;
        if (req && (!req.fileUrl || !req.fileName)) {
            req = this.transferModel(req);
        }
        if (!req || !req.fileUrl || !req.fileName) {
            return Promise.reject(new Error('[file] download no data required'));
        }
        if (conf === null || conf === void 0 ? void 0 : conf._account) {
            req._account = conf === null || conf === void 0 ? void 0 : conf._account;
        }
        const recordParams = {
            recordPerf: conf === null || conf === void 0 ? void 0 : conf.recordPerf,
            recordFileType: (conf === null || conf === void 0 ? void 0 : conf.recordFileType) || 'all',
        };
        if (this.systemApi.isElectron() && window.electronLib) {
            const shouldTrackCoreResult = (conf === null || conf === void 0 ? void 0 : conf.skipCoreResultTrack) !== true;
            const flowScene = conf === null || conf === void 0 ? void 0 : conf.flowScene;
            const downloadStartTime = Date.now();
            const getTrackDuration = () => Math.max(Date.now() - downloadStartTime, 0);
            const singleDownloadAttachmentKind = this.getSingleDownloadAttachmentKind(req, recordParams.recordFileType);
            const trackSingleDownloadResult = (result, reason, failType) => {
                if (!shouldTrackCoreResult || !flowScene) {
                    return;
                }
                const fallbackApi = singleDownloadAttachmentKind === 'cloud' ? 'attachment_download_cloud' : 'attachment_download';
                const apiValue = this.getDownloadCoreApiFromUrl(req.fileUrlInUse || req.fileUrl, fallbackApi);
                this.trackAttachmentDownloadCoreApiResult({
                    scene: flowScene,
                    api: apiValue,
                    attachmentKind: singleDownloadAttachmentKind,
                    result,
                    failType,
                    reason,
                    duration: getTrackDuration(),
                    _account: req._account,
                    fileType: req.fileType,
                    fileSize: req.fileSize,
                    fileCount: 1,
                });
            };
            if (recordParams.recordPerf) {
                mailPerfTool.attachmentTransfer('download', recordParams.recordFileType, 'start');
            }
            const rqUrl = this.httpApi.buildUrl(req.fileUrl, this.httpApi.getDeviceInfo() || {});
            req.fileUrlInUse = rqUrl;
            try {
                const [res, re] = await Promise.all([this.getFileInfo(req), this.testLocalFile(req)]);
                if (res && res.length > 0) {
                    let fileModel;
                    if (re) {
                        fileModel = res.find(it => it.filePath === req.filePath);
                    }
                    const delIds = res.filter(it => (fileModel ? it.filePath !== req.filePath && !!it.fid : !!it.fid));
                    this.fileDb.delBatch(delIds);
                    if (fileModel) {
                        trackSingleDownloadResult('success');
                        return {
                            succ: true,
                            fid: req.fid,
                            errMsg: '',
                            storeInLocal: true,
                            fileModel,
                        };
                    }
                }
            }
            catch (e) {
                console.warn('[file] got file from local :', e);
            }
            return this.downloadInternalOther(req, conf)
                .then(res => {
                const trackResult = res.succ ? 'success' : this.isDownloadCanceled(res.errMsg) ? 'canceled' : 'fail';
                trackSingleDownloadResult(trackResult, res.errMsg, trackResult === 'fail' ? this.getDownloadTrackFailType(res.errMsg) : undefined);
                if (recordParams.recordPerf) {
                    mailPerfTool.attachmentTransfer('download', recordParams.recordFileType, 'end', {
                        result: res.succ ? 'success' : 'fail',
                        fileSize: req.fileSize,
                        fileType: req.fileType,
                    });
                }
                return res;
            })
                .catch(ex => {
                console.warn('[file] downloadInternalOther ex', ex);
                const trackResult = this.isDownloadCanceled(ex) ? 'canceled' : 'fail';
                trackSingleDownloadResult(trackResult, ex, trackResult === 'fail' ? this.getDownloadTrackFailType(ex) : 'unknown');
                if (recordParams.recordPerf) {
                    mailPerfTool.attachmentTransfer('download', recordParams.recordFileType, 'end', {
                        result: 'fail',
                        fileSize: req.fileSize,
                        fileType: req.fileType,
                    });
                }
                return Promise.reject(new Error('[file] downloadInternalOther fail to download' + ex));
            });
        }
        return this.downloadExternal(req)
            .then(res => {
            if (recordParams.recordPerf) {
                mailPerfTool.attachmentTransfer('download', recordParams.recordFileType, 'end', {
                    result: res.succ ? 'success' : 'fail',
                    fileSize: req.fileSize,
                    fileType: req.fileType,
                });
            }
            return res;
        })
            .catch(err => {
            if (recordParams.recordPerf) {
                mailPerfTool.attachmentTransfer('download', recordParams.recordFileType, 'end', {
                    result: 'fail',
                    fileSize: req.fileSize,
                    fileType: req.fileType,
                });
            }
            return Promise.reject(err);
        });
    }
    testLocalFiles(items) {
        const result = { re: false, uselessItem: [] };
        if (!items || items.length === 0) {
            return result;
        }
        items.forEach(it => {
            if (!result.fileModel && it.filePath && window.electronLib.fsManage.isExist(it.filePath)) {
                result.fileModel = it;
            }
            else {
                result.uselessItem.push(it);
            }
        });
        return result;
    }
    transferModel(req) {
        if (req.fid === undefined) {
            req = this.registerTmpFile(req);
        }
        if (req.fid !== undefined) {
            if (req.fid <= 0) {
                const re = cloneDeep(this.store.getOb(-req.fid));
                if (re) {
                    re.filePath = req.filePath;
                    req = re;
                }
            }
        }
        return req;
    }
    downloadByLink(fileUrl, fileName) {
        try {
            const a = document.createElement('a');
            a.href = fileUrl;
            a.download = fileName;
            a.click();
        }
        catch (ex) {
            console.error('downloadByLink error', ex);
        }
    }
    downloadInOtherAppExternal(req) {
        if (req && req.fileUrl) {
            this.downloadByLink(req.fileUrl, req.fileName);
            return Promise.resolve({
                succ: true,
                fid: FileApiImp.invalidFid,
                errMsg: '',
                storeInLocal: false,
                fileModel: req,
            });
        }
        return Promise.reject(new Error('[file] downloadInOtherAppExternal no url set'));
    }
    downloadExternal(req) {
        if (req && req.fileUrl) {
            const msg = this.systemApi.openNewWindow(req.fileUrl);
            return Promise.resolve({
                succ: true,
                fid: FileApiImp.invalidFid,
                errMsg: msg,
                storeInLocal: false,
                fileModel: req,
            });
        }
        return Promise.reject(new Error('[file] downloadExternal no url set'));
    }
    sendLog(status) {
        let statSubKey = '';
        if (status === 'success') {
            statSubKey = 'success';
        }
        else if (status.indexOf('权限不足') !== -1) {
            statSubKey = 'noauth_error';
        }
        else if (status.indexOf('字节为空') !== -1) {
            statSubKey = 'emptybyte_error';
        }
        else if (status.indexOf('覆盖失败') !== -1) {
            statSubKey = 'cover_error';
        }
        else if (status.indexOf('文件保存错误') !== -1) {
            statSubKey = 'save_error';
        }
        else if (status.indexOf('文件下载超时') === -1) {
            statSubKey = 'timeout_error';
        }
        else if (status.indexOf('下载取消') !== -1) {
            statSubKey = 'download_cancel';
        }
        else if (status.indexOf('下载错误') !== -1) {
            statSubKey = 'download_error';
        }
        else {
            statSubKey = 'unknown_error';
        }
        this.performanceApi.point({
            statKey: 'fs_download',
            statSubKey,
            value: 1,
            valueType: 4,
        });
    }
    async downloadFile(req, conf) {
        const writer = await window.electronLib.fsManage.createWriteStream(req.fileName, req.filePath);
        console.log('---download,', conf);
        const response = await axios({
            method: 'get',
            url: req.fileUrl,
            responseType: 'stream',
            onDownloadProgress: conf && conf.progressIndicator
                ? (ev) => {
                    const percent = ev.loaded / (ev.total || req.fileSize || 10000000);
                    console.log('download ' + percent);
                    (conf === null || conf === void 0 ? void 0 : conf.progressIndicator) && (conf === null || conf === void 0 ? void 0 : conf.progressIndicator(percent));
                }
                : undefined,
        });
        return new Promise((resolve, reject) => {
            var _a;
            (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.pipe(writer);
            let error = null;
            writer.on('error', (err) => {
                console.warn('---- download:', err);
                error = err;
                writer.close();
            });
            writer.on('close', () => {
                console.log('download closed');
                if (!error) {
                    resolve(true);
                }
                else {
                    reject(error);
                }
            });
        });
    }
    async downloadSiriusFile(req) {
        if (req.fileUrl && req.fileName && req.filePath) {
            const siriusProtocol = 'sirius://sirius.file/';
            if (req.fileUrl.startsWith(siriusProtocol)) {
                const fromPath = decodeURIComponent(req.fileUrl.replace(siriusProtocol, ''));
                if (window.electronLib.fsManage.isExist(fromPath)) {
                    try {
                        await window.electronLib.fsManage.copy(fromPath, req.filePath);
                        console.log('[sirius file] return from electron lib:', req);
                        await this.storeFileInfo(Object.assign(Object.assign({}, req), { fileStatus: 'downloaded' }), true);
                        return {
                            succ: true,
                            fid: req.fid || -1,
                            errMsg: '',
                            storeInLocal: true,
                            fileModel: req,
                        };
                    }
                    catch (e) {
                        if (req.fileOriginUrl && !req.fileOriginUrl.startsWith(siriusProtocol)) {
                            return this.download(Object.assign(Object.assign({}, req), { fileUrl: req.fileOriginUrl }));
                        }
                        return Promise.reject(new Error('[sirius file] download SiriusFile file error'));
                    }
                }
                else if (req.fileOriginUrl && !req.fileOriginUrl.startsWith(siriusProtocol)) {
                    return this.download(Object.assign(Object.assign({}, req), { fileUrl: req.fileOriginUrl }));
                }
                else {
                    return Promise.reject(new Error('[sirius file] download SiriusFile file error'));
                }
            }
            return Promise.reject(new Error('[sirius file] download SiriusFile file url must be under sirius protocol'));
        }
        return Promise.reject(new Error('[sirius file] download SiriusFile error invalid req'));
    }
    async downloadInternalOther(req, conf) {
        if (req.fileUrl && req.fileName) {
            if (req.fileUrl.startsWith('sirius://sirius.file')) {
                return this.downloadSiriusFile(req);
            }
            const url = req.fileUrl;
            const file = this.getFsDownloadStatus(url);
            if ((file === null || file === void 0 ? void 0 : file.fileStatus) === 'downloading' || (file === null || file === void 0 ? void 0 : file.fileStatus) === 'downloadStart') {
                const msg = url + ' is already downloading';
                console.error(msg, file);
                return Promise.reject(msg);
            }
            this.setFsDownloadStatus(url, Object.assign(Object.assign({}, req), { fileStatus: 'downloadStart', fileReceivedBytes: 0 }));
            let onProgress;
            let sessionName = '';
            let setFsDownloadStatus;
            if (conf && conf.progressIndicator) {
                const progressThrottle = conf.progressThrottle === undefined ? true : conf.progressThrottle;
                if (progressThrottle) {
                    onProgress = throttle(conf.progressIndicator, conf.throttleTime || 1000, {
                        leading: true,
                    });
                }
                else {
                    onProgress = conf.progressIndicator;
                }
            }
            else {
                setFsDownloadStatus = throttle(this.setFsDownloadStatus, 500, {
                    leading: true,
                    trailing: true,
                });
            }
            const progressArr = [];
            if ((conf === null || conf === void 0 ? void 0 : conf._account) && this.mailConfApi.isSubAccount(conf === null || conf === void 0 ? void 0 : conf._account)) {
                sessionName = this.systemApi.getSessionNameOfSubAccount(conf._account);
            }
            return window.electronLib.downloadManage
                .download({
                sessionName,
                url,
                realUrl: req.fileUrlInUse,
                dirPath: req.dirPath,
                filePath: req.filePath,
                fileName: req.fileName,
                progress: (receivedBytes, totalBytes, progress) => {
                    var _a;
                    const _totalBytes = totalBytes <= 0 ? req.fileSize : totalBytes;
                    progress = progress || receivedBytes / _totalBytes;
                    const _progress = progress.toFixed(2);
                    if (!progressArr.includes(_progress)) {
                        progressArr.push(_progress);
                    }
                    if (((_a = this.getFsDownloadStatus(url)) === null || _a === void 0 ? void 0 : _a.fileStatus) !== 'downloading') {
                        this.setFsDownloadStatus(url, Object.assign(Object.assign({}, req), { fileStatus: 'downloading', fileReceivedBytes: receivedBytes, fileSize: _totalBytes, fileDownloadProgress: progress }));
                    }
                    if (onProgress) {
                        onProgress(progress, receivedBytes);
                    }
                    else {
                        setFsDownloadStatus.call(this, url, Object.assign(Object.assign({}, req), { fileStatus: 'downloading', fileReceivedBytes: receivedBytes, fileSize: _totalBytes, fileDownloadProgress: progress }));
                    }
                },
            })
                .then((rs) => {
                console.warn('download file return from electron lib:', rs);
                const storeData = Object.assign({}, req);
                storeData.filePath = rs.filePath;
                storeData.fileName = rs.fileName;
                storeData.fileMd5 = rs.md5;
                storeData.fileSize = rs.totalBytes;
                if (storeData.fid && storeData.fid < 0) {
                    storeData.fid = undefined;
                }
                if (rs.success) {
                    storeData.fileStatus = 'downloaded';
                    this.sendLog('success');
                    const storeFileFn = (conf === null || conf === void 0 ? void 0 : conf.noStoreData) ? () => Promise.resolve() : () => this.storeFileInfo(storeData);
                    return storeFileFn().then(() => {
                        const fileModel = Object.assign(Object.assign({}, storeData), { fileStatus: 'downloaded', fileReceivedBytes: rs.totalBytes, fileSize: rs.totalBytes });
                        setFsDownloadStatus ? setFsDownloadStatus.call(this, url, fileModel) : this.setFsDownloadStatus(url, fileModel);
                        return {
                            succ: true,
                            fid: storeData.fid,
                            errMsg: '',
                            storeInLocal: true,
                            fileModel,
                        };
                    });
                }
                try {
                    if (storeData.filePath) {
                        window.electronLib.fsManage.remove(storeData.filePath).then();
                    }
                }
                catch (e) {
                    console.error(e);
                }
                const fileModel = Object.assign(Object.assign({}, storeData), { fileStatus: 'downloadFailed', fileReceivedBytes: rs.totalBytes });
                setFsDownloadStatus ? setFsDownloadStatus.call(this, url, fileModel) : this.setFsDownloadStatus(url, fileModel);
                this.sendLog(rs.message);
                return {
                    succ: false,
                    fid: storeData.fid,
                    errMsg: rs.message,
                    storeInLocal: false,
                    fileModel,
                };
            })
                .catch((reason) => {
                console.error('downloadInternalOther', reason);
                return {
                    succ: false,
                    fid: FileApiImp.invalidFid,
                    errMsg: reason,
                    storeInLocal: true,
                    fileModel: req,
                };
            });
        }
        return Promise.reject(new Error('[file] downloadInternalOther file url is empty'));
    }
    judgeFileType(contentType, fileName) {
        const typeMapElement = contentType ? attachmentTypeMap[contentType] : undefined;
        if (typeMapElement) {
            return typeMapElement;
        }
        if (fileName) {
            const indexOf = fileName.lastIndexOf('.');
            if (indexOf > 0 && indexOf < fileName.length - 1) {
                return fileName.substring(indexOf + 1);
            }
        }
        return 'other';
    }
    openFile(file) {
        if (this.systemApi.isElectron() && window.electronLib) {
            file = this.transferModel(file);
            return this.testLocalFile(file).then(res => {
                if (res) {
                    if (file.filePath) {
                        window.electronLib.fsManage.open(file.filePath);
                        return Promise.resolve(true);
                    }
                    return this.getFileInfo(file).then((re) => {
                        if (re && re[0] && re[0].filePath) {
                            window.electronLib.fsManage.open(re[0].filePath);
                            return true;
                        }
                        return false;
                    });
                }
                return false;
            });
        }
        return Promise.reject(new Error('[file] openFile not support'));
    }
    async openFileFromDownload(filePath) {
        if (filePath) {
            const existRes = await window.electronLib.fsManage.isExist(filePath);
            if (existRes) {
                window.electronLib.fsManage.open(filePath);
                return true;
            }
            return false;
        }
        return false;
    }
    async openDirFromDownload(filePath) {
        if (filePath) {
            const existRes = await window.electronLib.fsManage.isExist(filePath);
            if (existRes) {
                window.electronLib.fsManage.show(filePath);
                return true;
            }
            return false;
        }
        return false;
    }
    selectFile(file) {
        if (this.systemApi.isElectron() && window.electronLib) {
            file = this.transferModel(file);
            return window.electronLib.windowManage
                .select({
                title: '保存',
                properties: ['promptToCreate', 'openDirectory'],
            })
                .then((re) => {
                if (re.success) {
                    const path = Array.isArray(re.path) && re.path.length ? re.path[0] : re.path.toString();
                    if (path) {
                        const movePath = this.buildMovePath(file, path);
                        return movePath;
                    }
                    return '';
                }
                return '';
            });
        }
        return Promise.reject(new Error('[file] selectFile not support'));
    }
    moveFilePath(file, re) {
        if (file.filePath) {
            window.electronLib.fsManage.move(file.filePath, re);
            file.filePath = re;
            this.storeFileInfo(file).then();
            return true;
        }
        return false;
    }
    async saveAs(file, conf) {
        if (this.systemApi.isElectron() && window.electronLib) {
            file = this.transferModel(file);
            const isFileExist = await this.testLocalFile(file);
            if (!isFileExist || !file.filePath) {
                return Promise.reject(new Error('[file] 本地文件不存在'));
            }
            const fileName = file.fileName.replace(/[:*|!$]+/gi, '_');
            const isSubAccount = this.mailConfApi.isSubAccount(file === null || file === void 0 ? void 0 : file._account);
            const { success, path } = await window.electronLib.windowManage.saveDialog({ fileName, openAsMainWindow: isSubAccount });
            if (success) {
                const fromPath = window.electronLib.fsManage.normalizePath(file.filePath);
                const toPath = window.electronLib.fsManage.normalizePath(path);
                const mode = (conf === null || conf === void 0 ? void 0 : conf.mode) || 'copy';
                if (mode === 'copy') {
                    await window.electronLib.fsManage.copy(fromPath, toPath);
                }
                else {
                    await window.electronLib.fsManage.move(fromPath, toPath);
                }
                if (conf === null || conf === void 0 ? void 0 : conf.saveStore) {
                    file.filePath = toPath;
                    this.storeFileInfo(file)
                        .then()
                        .catch(e => {
                        console.error('[file] saveAs error when storeFileInfo', e);
                    });
                }
                return true;
            }
            return false;
        }
        return Promise.reject(new Error('[file] saveAs not support'));
    }
    show(file) {
        if (this.systemApi.isElectron() && window.electronLib) {
            file = this.transferModel(file);
            return this.testLocalFile(file).then(re => {
                if (re && file.filePath) {
                    window.electronLib.fsManage.show(file.filePath);
                    return true;
                }
                return false;
            });
        }
        return Promise.reject(new Error('[file] show not support'));
    }
    openDir(filePath) {
        if (this.systemApi.isElectron() && window.electronLib) {
            const isExist = window.electronLib.fsManage.isExist(filePath);
            if (isExist) {
                window.electronLib.fsManage.show(filePath);
                return true;
            }
        }
        return false;
    }
    testLocalFile(file) {
        if (this.systemApi.isElectron() && window.electronLib) {
            if (file.filePath) {
                const b = window.electronLib.fsManage.isExist(file.filePath);
                return Promise.resolve(b);
            }
            file = this.transferModel(file);
            return this.getFileInfo(file).then((res) => {
                const { re } = this.testLocalFiles(res);
                return re;
            });
        }
        return Promise.reject(new Error('[file] testLocalFile not support'));
    }
    async uploadPieceByPiece(url, content, uploader) {
        const { file, fileName, fileSize } = content;
        const originOffset = uploader ? (uploader === null || uploader === void 0 ? void 0 : uploader.offset) || 0 : 0;
        const baseAttrs = {
            url,
            fileName,
            fileSize,
            func: 'uploadPieceByPiece',
            originOffset,
        };
        const startTime = new Date().getTime();
        const { firstUploadAction } = uploader;
        let uploadCount = 0;
        let over50 = !(originOffset / fileSize < 0.5);
        let over90 = !(originOffset / fileSize < 0.9);
        if (!file)
            throw new Error('参数错误，上传的文件不存在');
        const headers = uploader.headers || {};
        headers['Content-Type'] = file.type + ';charset=UTF-8';
        let canceled = false;
        let httpCancel;
        if (uploader && uploader.operatorSet) {
            uploader.operatorSet(operation => {
                if (operation === 'abort') {
                    canceled = true;
                    if (httpCancel) {
                        httpCancel(operation);
                    }
                }
            });
        }
        uploader.headers = headers;
        const confHolder = uploader;
        const loadAction = async (cnf) => {
            var _a;
            let conf = cnf;
            if (!conf)
                return undefined;
            const start = uploader.offset;
            const count = uploader.sliceSize + uploader.offset > file.size ? file.size - uploader.offset : uploader.sliceSize;
            const slice = file === null || file === void 0 ? void 0 : file.slice(start, start + count);
            const isComplete = uploader.sliceSize + uploader.offset >= file.size;
            const reqConfig = {
                contentType: 'stream',
                headers: {
                    'x-nos-token': uploader.token,
                },
                params: {
                    offset: conf.offset,
                    complete: isComplete,
                    context: conf.context,
                    version: '1.0',
                },
            };
            const config = Object.assign(Object.assign(Object.assign(Object.assign({}, this.commonPieceUploadConf), { onUploadProgress: (ev) => {
                    const pr = (start + ev.loaded) / ((file === null || file === void 0 ? void 0 : file.size) || 100000000);
                    if (uploader && uploader.progressIndicator) {
                        uploader.progressIndicator(pr);
                    }
                }, operator: (handler) => {
                    httpCancel = handler;
                } }), reqConfig), conf);
            const arrayBufferSlice = await slice.arrayBuffer();
            const res = await this.httpApi.post(config.url || url, arrayBufferSlice, config);
            const { status, data } = res;
            if (status === 200 && data) {
                if (uploadCount === 0 && firstUploadAction) {
                    firstUploadAction(data);
                }
                uploadCount += 1;
                const { offset } = data;
                const curProgress = offset / fileSize;
                try {
                    if (curProgress > 0.5 && !over50) {
                        over50 = true;
                        this.performanceApi.point({
                            statKey: 'mail_attachment_uploading',
                            statSubKey: this.systemApi.md5(`${fileName}---${fileSize}---50`),
                            value: new Date().getTime() - startTime,
                            valueType: 1,
                            params: baseAttrs,
                        });
                    }
                    if (curProgress > 0.9 && !over90) {
                        over90 = true;
                        this.performanceApi.point({
                            statKey: 'mail_attachment_uploading',
                            statSubKey: this.systemApi.md5(`${fileName}---${fileSize}---90`),
                            value: new Date().getTime() - startTime,
                            valueType: 1,
                            params: baseAttrs,
                        });
                    }
                    if (offset >= fileSize) {
                        this.performanceApi.point({
                            statKey: 'mail_attachment_uploading',
                            statSubKey: this.systemApi.md5(`${fileName}---${fileSize}---100`),
                            value: new Date().getTime() - startTime,
                            valueType: 1,
                            params: baseAttrs,
                        });
                    }
                }
                catch (error) {
                    console.log('mail_attachment_uploading error', error);
                }
            }
            if (!((_a = res.config) === null || _a === void 0 ? void 0 : _a.canceled)) {
                content.fileStatus = 'uploaded';
                uploader.status = 'uploading';
                if (canceled) {
                    res.config.canceled = true;
                    return res;
                }
                if (!res.config.canceled) {
                    conf = uploader.nextUploader(res);
                    if (conf) {
                        content.uploadContext = conf.context;
                        content.uploadOffset = conf.offset;
                        content.originOffset = originOffset;
                        console.log('continue uploaded:' + res.uri, conf);
                        return loadAction(conf);
                    }
                    console.log('successfully uploaded:' + res.uri, conf);
                }
            }
            return res;
        };
        try {
            if (!originOffset) {
                this.performanceApi.point({
                    statKey: 'mail_attachment_uploading',
                    statSubKey: this.systemApi.md5(`${fileName}---${fileSize}---0`),
                    value: 0,
                    valueType: 1,
                    params: baseAttrs,
                });
            }
        }
        catch (error) {
            console.log('mail_attachment_uploading error', error);
        }
        const result = loadAction(confHolder);
        return result || Promise.reject(new Error('[file] uploadPieceByPiece 未知错误'));
    }
    upload(url, content, uploader) {
        const { file, fileName, fileSize } = content;
        const originOffset = uploader ? (uploader === null || uploader === void 0 ? void 0 : uploader.offset) || 0 : 0;
        const baseAttrs = {
            url,
            fileName,
            fileSize,
            func: 'upload',
            originOffset,
        };
        if (!file) {
            throw new Error('参数错误，上传的文件不存在');
        }
        const startTime = new Date().getTime();
        let over50 = !(originOffset / fileSize < 0.5);
        let over90 = !(originOffset / fileSize < 0.9);
        const headers = (uploader === null || uploader === void 0 ? void 0 : uploader.headers) || {};
        headers['Content-Type'] = file.type;
        try {
            if (!originOffset) {
                this.performanceApi.point({
                    statKey: 'mail_attachment_uploading',
                    statSubKey: this.systemApi.md5(`${fileName}---${fileSize}---0`),
                    value: 0,
                    valueType: 1,
                    params: baseAttrs,
                });
            }
        }
        catch (error) {
            console.log('mail_attachment_uploading error', error);
        }
        return this.httpApi
            .post(url, file, Object.assign({ contentType: 'stream', onUploadProgress: (ev) => {
                const { loaded, total } = ev;
                const curProgress = loaded / total;
                try {
                    if (curProgress > 0.5 && !over50) {
                        over50 = true;
                        this.performanceApi.point({
                            statKey: 'mail_attachment_uploading',
                            statSubKey: this.systemApi.md5(`${fileName}---${fileSize}---50`),
                            value: new Date().getTime() - startTime,
                            valueType: 1,
                            params: baseAttrs,
                        });
                    }
                    if (curProgress > 0.9 && !over90) {
                        over90 = true;
                        this.performanceApi.point({
                            statKey: 'mail_attachment_uploading',
                            statSubKey: this.systemApi.md5(`${fileName}---${fileSize}---90`),
                            value: new Date().getTime() - startTime,
                            valueType: 1,
                            params: baseAttrs,
                        });
                    }
                    if (loaded >= fileSize) {
                        this.performanceApi.point({
                            statKey: 'mail_attachment_uploading',
                            statSubKey: this.systemApi.md5(`${fileName}---${fileSize}---100`),
                            value: new Date().getTime() - startTime,
                            valueType: 1,
                            params: baseAttrs,
                        });
                    }
                }
                catch (error) {
                    console.log('mail_attachment_uploading error', error);
                }
                const pr = (loaded * 1.0) / ((file === null || file === void 0 ? void 0 : file.size) || 100000000);
                if (uploader && uploader.progressIndicator) {
                    uploader.progressIndicator(pr);
                }
            }, headers, operator: uploader && uploader.operatorSet, timeout: 20 * 60 * 1000 }, uploader))
            .then((res) => {
            var _a;
            if (!((_a = res.config) === null || _a === void 0 ? void 0 : _a.canceled) && res.status >= 200 && res.status <= 206) {
                content.fileStatus = 'uploaded';
                return res;
            }
            return res;
        });
    }
    uploadFile(file) {
        const fileFormData = new FormData();
        fileFormData.append('file', file.file, file.fileName);
        fileFormData.append('type', 'signature');
        const url = this.systemApi.getUrl('uploadFile');
        return this.httpApi.post(url, fileFormData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                accept: '*/*',
            },
            timeout: 20 * 60 * 1000,
            contentType: 'stream',
        });
    }
    saveTmpFile(files) {
        console.log(files);
        throw new Error('');
    }
    registerTmpFile(file) {
        const { key } = this.getFileKey(file);
        let id;
        if (key in this.fileIndex) {
            id = this.fileIndex[key];
        }
        else {
            id = -this.store.addOb(file);
            this.fileIndex[key] = id;
        }
        file.fid = id;
        return file;
    }
    getAttachmentZipPath(mid) {
        return this.fileDb.dbApi.getById(mailTable.status, mid).then(re => (re === null || re === void 0 ? void 0 : re.attachmentsZipPath) || '');
    }
    getFileInfo(file) {
        const fileKey = this.getFileKey(file);
        return this.fileDb.get(fileKey.key, fileKey.field, file._account).then((re) => {
            let res;
            if (re && re.length >= 1) {
                res = re[re.length - 1];
            }
            console.log('getFileInfo', res, re);
            return res ? [res] : re;
        });
    }
    getFileInfoByFileName(fileName) {
        if (!fileName) {
            return Promise.resolve([]);
        }
        let name = '';
        let ext = '';
        const fileNameArr = fileName === null || fileName === void 0 ? void 0 : fileName.split('.');
        if (fileNameArr.length > 1) {
            name = fileNameArr[fileNameArr.length - 2];
            ext = fileNameArr[fileNameArr.length - 1];
        }
        else {
            name = fileName;
        }
        return this.fileDb.dbApi
            .getByRangeCondition({
            dbName: 'fileop',
            tableName: 'file',
            adCondition: {
                type: 'startsWithIgnoreCase',
                field: 'fileName',
                args: [name],
            },
        })
            .then(re => {
            let res;
            if (re && re.length >= 1) {
                res = ext ? re.filter(item => item.fileName.endsWith(ext)) : re;
            }
            console.log('getFileInfoByFileName', res, re);
            return res;
        });
    }
    storeFileInfo(file, update = false) {
        return this.getFileInfo(file).then((re) => {
            const targetFile = update && re && re.length === 1
                ? Object.assign(Object.assign({}, re[0]), file) : file;
            console.log('got file related ', targetFile, re);
            return this.fileDb.put(targetFile).then(rs => {
                console.log('file stored:', rs);
                return rs;
            });
        });
    }
    delFileInfo(file) {
        if (file.fid && file.fileUrl) {
            this.fileDb.del(file.fid, file._account);
            this.clearFsDownloadStatus(file.fileUrl);
        }
        else {
            console.error('[file] delFileInfo no fid', file);
        }
    }
    async delAttachmentZipPath(mid) {
        const mailStatus = await this.fileDb.dbApi.getById(mailTable.status, mid);
        if (mailStatus) {
            mailStatus.attachmentsZipPath = '';
            await this.fileDb.dbApi.put(mailTable.status, mailStatus);
        }
    }
    getFileKey(file) {
        if (file.fid && file.fid > 0) {
            return {
                key: file.fid,
                field: 'fid',
            };
        }
        if (file.fileOriginUrl) {
            return {
                key: file.fileOriginUrl,
                field: 'fileOriginUrl',
            };
        }
        if (file.fileUrl) {
            return {
                key: file.fileUrl,
                field: 'fileUrl',
            };
        }
        if (file.fileMd5 && file.fileMd5.length > 10) {
            return {
                key: file.fileMd5,
                field: 'fileMd5',
            };
        }
        if (file.fileSourceKey) {
            return {
                key: file.fileSourceKey,
                field: 'fileSourceKey',
            };
        }
        if (file.filePath) {
            return {
                key: file.filePath,
                field: 'filePath',
            };
        }
        throw new Error('no identified field');
    }
    buildMovePath(file, path) {
        const home = window.electronLib.env.isMac ? '/Downloads' : '\\Downloads';
        if (file && file.fileName) {
            return window.electronLib.env.isMac ? path + '/' + file.fileName : path + '\\' + file.fileName;
        }
        if (file && file.filePath && path) {
            let indexOf = file.filePath.lastIndexOf('/');
            if (indexOf < 0) {
                indexOf = file.filePath.lastIndexOf('\\');
            }
            if (indexOf < 0) {
                return home;
            }
            return path + file.filePath.substring(indexOf);
        }
        return home;
    }
    async asyncPool(params) {
        const { num, infos, func, conf } = params;
        const result = [];
        let count = 0;
        const infosLength = infos.length;
        return new Promise((resolve, reject) => {
            const next = () => {
                count += 1;
                func(infos.shift(), conf)
                    .then((res) => {
                    result.push(res);
                    if (infos.length > 0) {
                        next();
                    }
                    else if (result.length === infosLength) {
                        resolve(result);
                    }
                })
                    .catch((err) => {
                    reject(err);
                });
            };
            while (count < num && infos.length > 0) {
                next();
            }
        });
    }
}
FileApiImp.invalidFid = -10000000;
const fileApi = new FileApiImp();
api.registerFileApi(fileApi);
export default fileApi;
